import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ForgotPasswordForm = ({
  layout
}: {
  layout?: 'simple' | 'card' | 'split';
}) => {
  return (
    <div className={classNames({ 'px-xxl-5': !(layout === 'split') })}>
      <div
        className={classNames('text-center', { 'mb-6': !(layout === 'split') })}
      >
        <h4 className="text-1000">비밀번호 찾기</h4>
        <p className="text-700 mb-5">
          이메일 주소를 입력하세요 <br className="d-sm-none" />
          비밀번호 설정을 위한 메일을 발송합니다
        </p>
        <Form className="d-flex align-items-center mb-5">
          <Form.Control
            type="email"
            id="email"
            className="flex-1"
            placeholder="이메일"
          />
          <Button
            variant="primary"
            className="ms-2"
            endIcon={<FontAwesomeIcon icon={faChevronRight} className="ms-2" />}
          >
            보내기
          </Button>
        </Form>
        {/* <Link to="#!" className="fs-9 fw-bold">
          Still having problems?
        </Link> */}
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
